export class WebAppInfo {
  public readonly appVersion = "1.5.19 (5)";

}
